import { Divider } from "@/components/ui/Divider";

import { Button } from "equator-design-system";
import { twMerge } from "tailwind-merge";

type Props = {
  label: string;
  className?: string;
  data: { label: string; value: string; disabled?: boolean }[];
  itemSelected: string;
  showDivider?: boolean;
  onSelect: (data: string) => void;
};

const BadgeSelect = ({
  label,
  className,
  itemSelected,
  data = [],
  showDivider = false,
  onSelect
}: Props) => {
  return (
    <div className={twMerge("flex flex-col gap-2", className)}>
      {!!label && (
        <span className="text-[12px] font-semibold" data-testid="badge-label">
          {label}
        </span>
      )}
      <div className="flex gap-3 flex-wrap">
        {data.map((item) => (
          <Button
            key={item.value}
            className={twMerge(
              "w-fit h-auto py-1 px-2 border border-gainsboro bg-white rounded-lg disabled:cursor-not-allowed text-[12px] font-bold text-txtBody focus:outline-none",
              itemSelected === item.value &&
                "border-teal-200 text-teal-500 bg-teal-50",
              item.disabled && "text-gainsboro bg-white-smoke border-gainsboro"
            )}
            disabled={item.disabled}
            onClick={() => {
              if (!item.disabled) {
                onSelect(item.value);
              }
            }}
          >
            <span>{item.label}</span>
          </Button>
        ))}
      </div>
      {showDivider && (
        <Divider className="bg-gainsboro w-[100%] h-[1px] mt-4" />
      )}
    </div>
  );
};

export default BadgeSelect;
